module.exports = __webpack_public_path__ + "static/img/hllogo.d46dd690.png";